module.exports = __webpack_public_path__ + "static/img/user_2.5fffcde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/user_2.png
// module id = U2oK
// module chunks = 0